import type { AssetListItem } from '@fleet-bffs/api-contract';
import formatMessageWrapper from '~/utils/format-message-wrapper/format-message-wrapper';
import type { Operation } from '~/domain/assets/models/Operation';
import { rebootActionTypes } from '../../utils/actionsTypes';
import type { OperationFailureIndicatorItem } from './types';

export const formatOperationFailureIndication = (
  asset: AssetListItem,
  operation: Operation
): OperationFailureIndicatorItem => {
  if (rebootActionTypes.includes(operation.hfsActionId)) {
    return {
      iprId: operation.iprId,
      hfsActionId: operation.hfsActionId,
      toastTitle: asset?.assetDetails?.name,
      toastMessage: formatMessageWrapper('web.restart_machine.failure.title'),
      modalTitle: formatMessageWrapper('web.restart_machine.failure.title'),
      modalMessage: formatMessageWrapper('web.restart_machine.failure.message'),
    };
  }
  return {
    iprId: operation.iprId,
    hfsActionId: operation.hfsActionId,
    toastTitle: asset?.assetDetails?.name,
    toastMessage: formatMessageWrapper('web.robotic_mower.additional_commands.failure.message'),
    modalTitle: formatMessageWrapper('web.robotic_mower.additional_commands.failure.title'),
    modalMessage: formatMessageWrapper('web.robotic_mower.additional_commands.failure.message'),
  };
};
